import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { updatePatient } from '../../../utilities/API/applicationSubmitServices';

export const patientDetailsUpdate = createAsyncThunk(
    'updatePatient', updatePatient
)

const initialState = {
    value: [
    ]
}

const updatePatientSlice = createSlice({
    name: 'fundSpecificLookupSlice',
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(patientDetailsUpdate.pending, (state, action) => {
                // toast.warn("PreQualQuestions pending")
            })
            .addCase(patientDetailsUpdate.fulfilled, (state, action) => {
            })
            .addCase(patientDetailsUpdate.rejected, (state, action) => {
                // toast.error(action.error.message)
            })
    },
})


export default updatePatientSlice.reducer